
function Documents({ title, subtitle, items }) {
  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const headerCellStyle = { border: "1px solid #ddd", padding: "10px", fontWeight: 600, background: "#f9f9f9" };
  const cellStyle = { border: "1px solid #ddd", padding: "10px" };
  const pdfCellStyle = { ...cellStyle, textAlign: "center", width: "90px" };
  const indexCellStyle = { ...cellStyle, textAlign: "center", width: "80px" };

  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'fa-file-pdf';
      case 'doc':
      case 'docx':
        return 'fa-file-word';
      case 'xls':
      case 'xlsx':
        return 'fa-file-excel';
      case 'png':
      case 'jpg':
      case 'jpeg':
        return 'fa-file-image';
      default:
        return 'fa-file';
    }
  };

  return (
    <div className="tp-service-3-area pt-80 pb-50">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="tp-service-title-box text-center mb-70">
              <span className="tp-section-subtitle">
                {subtitle || "Documentos para el trabajo municipal"}
              </span>
              <h4 className="tp-section-title">{title}</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={{ ...headerCellStyle, width: "80px", textAlign: "center" }}>Item</th>
                  <th style={headerCellStyle}>Título</th>
                  <th style={{ ...headerCellStyle, textAlign: "center" }}>Documento</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td style={indexCellStyle}>{index + 1}</td>
                    <td style={cellStyle}>{item.title}</td>
                    <td style={pdfCellStyle}>
                      <a href={item.path} target={item.target} rel="noopener noreferrer" aria-label={`Abrir: ${item.title}`}>
                        <i className={`fal ${getFileIcon(item.title)}`} style={{ fontSize: '20px' }} />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Documents;
